import React, { useState } from 'react';
import { Card, Button, Container, Row, Col, Form, Tabs, Tab } from 'react-bootstrap';
import { collection, query, where, getDocs, Timestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { FaChartBar } from 'react-icons/fa';

const ProductMarketFitDashboard = () => {
  const [selectedDate, setSelectedDate] = useState('');
  const [submittedDate, setSubmittedDate] = useState('');
  const [totalSessions, setTotalSessions] = useState(0);
  const [lessonTypeCounts, setLessonTypeCounts] = useState({
    magicMoment: 0,
    onboardingSession: 0,
  });
  const [userChallengeCount, setUserChallengeCount] = useState(0);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedDate) return;

    const start = new Date(selectedDate);
    start.setHours(0, 0, 0, 0);
    const end = new Date(start);
    end.setDate(end.getDate() + 1);

    // Fetch from userpracticesessions
    const sessionQuery = query(
      collection(db, 'userpracticesessions'),
      where('date', '>=', Timestamp.fromDate(start)),
      where('date', '<', Timestamp.fromDate(end))
    );

    const sessionSnapshot = await getDocs(sessionQuery);
    const sessionDocs = sessionSnapshot.docs.map(doc => doc.data());

    const counts = { magicMoment: 0, onboardingSession: 0 };
    sessionDocs.forEach((doc) => {
      const lessonId = (doc.lessonid || '').trim();
      if (lessonId === 'magic-moment-1.0') counts.magicMoment++;
      if (lessonId === '1.0') counts.onboardingSession++;
    });

    setTotalSessions(sessionDocs.length);
    setLessonTypeCounts(counts);
    setSubmittedDate(selectedDate);

    // Fetch from userchallengesession
    const challengeQuery = query(
      collection(db, 'userchallengesessions'),
      where('date', '>=', Timestamp.fromDate(start)),
      where('date', '<', Timestamp.fromDate(end))
    );

    const challengeSnapshot = await getDocs(challengeQuery);
    setUserChallengeCount(challengeSnapshot.size);
  };

  return (
    <Container className="my-5">
      <h2 style={{ color: '#FF7C24', fontWeight: 'bold' }}>
        <FaChartBar className="me-2" /> Product Market Fit Dashboard
      </h2>

      <Form onSubmit={handleSubmit} className="mb-4">
        <Form.Group controlId="datePicker">
          <Form.Label className="mt-3">Select Date</Form.Label>
          <Form.Control
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
        </Form.Group>
        <Button type="submit" className="mt-3" variant="warning">
          Fetch Data
        </Button>
      </Form>

      <Tabs defaultActiveKey="practiceSessions" id="dashboard-tabs" className="mb-3">
        <Tab eventKey="practiceSessions" title="Practice Sessions">
          <Row>
            <Col md={6}>
              <Card className="p-4 mb-4 shadow-sm">
                <h4>North Star Metric</h4>
                <h2 style={{ color: '#FF7C24' }}>{totalSessions}</h2>
                <p className="bg-light text-dark p-2 rounded w-75">Total Practice Sessions</p>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="p-4 mb-4 shadow-sm">
                <h4>Lesson Types</h4>
                <ul>
                  <li>Magic Moment: <strong>{lessonTypeCounts.magicMoment}</strong></li>
                  <li>Onboarding Session: <strong>{lessonTypeCounts.onboardingSession}</strong></li>
                </ul>
              </Card>
            </Col>
          </Row>
        </Tab>

        <Tab eventKey="challengeSessions" title="User Challenge Sessions">
          <Card className="p-4 shadow-sm">
            <h4>User Challenge Sessions</h4>
            <p className="display-6" style={{ color: '#FF7C24' }}>{userChallengeCount}</p>
            <p className="bg-light text-dark p-2 rounded w-75">Total Challenges Started</p>
          </Card>
        </Tab>
      </Tabs>
    </Container>
  );
};

export default ProductMarketFitDashboard;
